module.exports = __webpack_public_path__ + "img/icon_other.963f36c2.svg";